/* eslint-disable react/prop-types */
import { forwardRef } from 'react';
import { FaCheckCircle, FaClock } from 'react-icons/fa';
import { ControllerAlert as Alert, Tooltip } from '@bymason-private/legacy-pattern-components';
import { STATUS_TOOLTIP_MESSAGES } from '../../app-constants';

export const UpdatedAlert = forwardRef<HTMLDivElement, UpdatedAlertProps>(function UpdatedAlert(props, ref) {
  const {
    value = false,
    suppressIcon,
    variant = 'standard',
    trueText = 'Updated',
    falseText = 'Out-of-date',
    ...rest
  } = props;

  return (
    <Alert
      {...rest}
      ref={ref}
      variant={variant}
      severity={value ? 'success' : 'warning'}
      icon={suppressIcon ? <span /> : value ? <FaCheckCircle fontSize={16} /> : <FaClock fontSize={16} />}
      sx={(theme) => ({
        padding: '4px 10px 4px 8px',
        [`&.MuiAlert-${variant}${value ? 'Success' : 'Warning'}`]: {
          color: theme.palette.text.primary,
          backgroundColor: 'transparent',
          padding: 0,
          lineHeight: 'inherit',
          fontSize: 'inherit',
          alignItems: 'center',
        },
        '& .MuiAlert-icon': {
          marginRight: '4px',
          marginBottom: '2px',
          borderRadius: '50%',
          backgroundColor: theme.palette.background.default,
          padding: 0,
        },
      })}
    >
      {value ? trueText : falseText}
    </Alert>
  );
});

interface UpdatedAlertProps {
  value?: boolean;
  suppressIcon?: boolean;
  variant?: 'standard' | 'outlined';
  trueText?: string;
  falseText?: string;
}

export const UpdatedAlertWithTooltip = ({ statusType, value, ...props }: UpdatedAlertWithTooltipProps) => {
  const messageUpdated = STATUS_TOOLTIP_MESSAGES[statusType].updated;
  const messageOutOfDate = STATUS_TOOLTIP_MESSAGES[statusType].outOfDate;

  return (
    <Tooltip title={value ? messageUpdated : messageOutOfDate} arrow placement='top-start'>
      <UpdatedAlert value={value} {...props} />
    </Tooltip>
  );
};

interface UpdatedAlertWithTooltipProps extends UpdatedAlertProps {
  statusType: 'project' | 'os' | 'apps';
}
